// extracted by mini-css-extract-plugin
export var quillEditor = "_98-1";
export var variable = "_98-0";